import React, { useContext, ReactNode, useEffect } from 'react';
import { useLocalStorage } from '@mantine/hooks';
import { useLanguage } from './LanguageProvider';
import { useQuery } from '@tanstack/react-query';
import StoreApi, { Store } from '@/api/StoreApi';

interface Context {
	store: Store | null;
	setStore: (store: Store) => void;
}

const ContentContext = React.createContext<Context>(null!);

export const useStore = () => useContext(ContentContext);

export const StoreProvider = ({ children }: { children: ReactNode }) => {
	const setLanguage = useLanguage().setLanguage;

	useQuery({
		queryKey: [StoreApi.queryKey],
		queryFn: StoreApi.getAll,
	});

	const [store, setStore] = useLocalStorage<Context['store']>({
		key: 'store',
		defaultValue: null,
		getInitialValueInEffect: false,
	});

	useEffect(() => {
		if (!store) return;
		setLanguage(store.language);
	}, [store]);

	return (
		<ContentContext.Provider
			value={{
				store,
				setStore,
			}}
		>
			{children}
		</ContentContext.Provider>
	);
};
